var search = "Search";
var off = "Off";
var minutesAndSecondsAbbr = "{{m}}m:{{s}}s";
var minutesAbbr = "{{m}}m";
var minRange = "Minimum {{seconds}}s";
var minMonth = "Minimum {{months}} month(s)";
var secondsAbbr = "{{s}}s";
var year = "Year";
var month = "Month";
var relTime_s = "Seconds after now";
var relTime_m = "Minutes after now";
var relTime_h = "Hours after now";
var relTime_d = "Days after now";
var clearFilter = "Clear Filter";
var absolute = "absolute";
var relative = "relative";
var now = "Now";
var relativeToNow = "Relative to now";
var loading = "Loading";
var noContent = "No content";
var hideAll = "Hide all";
var showAll = "Show all";
var rowsPerPage = "Rows per page";
var noOptions = "No options";
var cancel = "Cancel";
var confirm = "Confirm";
var submit = "Submit";
var logout = "Logout";
var columns = "Columns";
var density = "Density";
var compact = "Compact";
var standard = "Standard";
var resetTable = "Reset table";
var undo = "Undo";
var redo = "Redo";
var bold = "Bold";
var italic = "Italic";
var underline = "Underline";
var strikethrough = "Strikethrough";
var code = "Code block";
var link = "Link";
var clearFormat = "Clear format";
var noFiles = "No files";
var copyToClipboard = "Copy To Clipboard";
var uploadedFile = "Uploaded file";
var uploadedFile_plural = "Uploaded files";
var name = "Name";
var size = "Size";
var createdAt = "Created";
var updatedAt = "Modified";
var mustLeq0 = "Must be >= 0";
var en = {
	search: search,
	off: off,
	minutesAndSecondsAbbr: minutesAndSecondsAbbr,
	minutesAbbr: minutesAbbr,
	minRange: minRange,
	minMonth: minMonth,
	secondsAbbr: secondsAbbr,
	year: year,
	month: month,
	"relTime_-s": "Seconds ago",
	"relTime_-m": "Minutes ago",
	"relTime_-h": "Hours ago",
	"relTime_-d": "Days ago",
	relTime_s: relTime_s,
	relTime_m: relTime_m,
	relTime_h: relTime_h,
	relTime_d: relTime_d,
	clearFilter: clearFilter,
	absolute: absolute,
	relative: relative,
	now: now,
	relativeToNow: relativeToNow,
	loading: loading,
	noContent: noContent,
	hideAll: hideAll,
	showAll: showAll,
	rowsPerPage: rowsPerPage,
	noOptions: noOptions,
	cancel: cancel,
	confirm: confirm,
	submit: submit,
	logout: logout,
	columns: columns,
	density: density,
	compact: compact,
	standard: standard,
	resetTable: resetTable,
	"block.paragraph": "Normal",
	"block.h1": "Heading 1",
	"block.h2": "Heading 2",
	"block.h3": "Heading 3",
	"block.ul": "Bullet List",
	"block.ol": "Number List",
	"block.check-list": "Check List",
	"block.quote": "Quote",
	"block.code": "Code",
	undo: undo,
	redo: redo,
	bold: bold,
	italic: italic,
	underline: underline,
	strikethrough: strikethrough,
	code: code,
	link: link,
	clearFormat: clearFormat,
	"export": "Export",
	"export.all": "All pages",
	"export.currentPage": "Current page",
	"table.insertRowAbove": "Insert {{n}} rows above",
	"table.insertRowBelow": "Insert {{n}} rows below",
	"table.insertColumnLeft": "Insert {{n}} column left",
	"table.insertColumnRight": "Insert {{n}} column right",
	"table.deleteRow": "Delete row",
	"table.deleteColumn": "Delete column",
	"table.deleteTable": "Delete table",
	noFiles: noFiles,
	"fileUploader.drop-failed": "Drop failed",
	"fileUploader.too-many-files": "Only {{n}} file(s) can be uploaded at once",
	"fileUploader.file-too-large": "File size should be less than {{size}}",
	"fileUploader.file-exists": "{{fileName}} is exists",
	"fileUploader.file-invalid-type": "Invalid file type",
	copyToClipboard: copyToClipboard,
	uploadedFile: uploadedFile,
	uploadedFile_plural: uploadedFile_plural,
	name: name,
	size: size,
	createdAt: createdAt,
	updatedAt: updatedAt,
	mustLeq0: mustLeq0
};

export { absolute, bold, cancel, clearFilter, clearFormat, code, columns, compact, confirm, copyToClipboard, createdAt, en as default, density, hideAll, italic, link, loading, logout, minMonth, minRange, minutesAbbr, minutesAndSecondsAbbr, month, mustLeq0, name, noContent, noFiles, noOptions, now, off, redo, relTime_d, relTime_h, relTime_m, relTime_s, relative, relativeToNow, resetTable, rowsPerPage, search, secondsAbbr, showAll, size, standard, strikethrough, submit, underline, undo, updatedAt, uploadedFile, uploadedFile_plural, year };
